document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".accordion_trigger > button").forEach((button) => {
    button.addEventListener("click", function () {
      const content = this.nextElementSibling;
      const isActive = this.classList.contains("active");

      // Close all other accordions
      document.querySelectorAll(".accordion_trigger > button").forEach((btn) => {
        if (btn !== this) {
          btn.classList.remove("active");
          const otherContent = btn.nextElementSibling;
          otherContent.classList.remove("open_accordion");
          otherContent.style.maxHeight = null;
          otherContent.style.paddingTop = "0";
          otherContent.style.paddingBottom = "0";
          btn.querySelector(".icon-plus").style.display = "inline";
          btn.querySelector(".icon-minus").style.display = "none";
        }
      });

      if (isActive) {
        // Close the current accordion if it's active
        this.classList.remove("active");
        content.classList.remove("open_accordion");
        content.style.maxHeight = null;
        content.style.paddingTop = "0";
        content.style.paddingBottom = "0";
        this.querySelector(".icon-plus").style.display = "inline";
        this.querySelector(".icon-minus").style.display = "none";
      } else {
        // Open the clicked accordion
        this.classList.add("active");
        content.classList.add("open_accordion");
        content.style.paddingTop = "5px";
        content.style.paddingBottom = "10px";
        content.style.maxHeight = content.scrollHeight + 20 + "px";
        this.querySelector(".icon-plus").style.display = "none";
        this.querySelector(".icon-minus").style.display = "inline";
      }
    });
  });
});

$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('.omnisend-reset-64516494e54adad5ac574ba4.omnisend-form-64516494e54adad5ac574ba4-container').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("Customer Email Laoding");
$('.omnisend-reset-64516494e54adad5ac574ba4.omnisend-form-64516494e54adad5ac574ba4-container').attr('aria-label', 'Get 20% off promotional-form');
$('.omnisend-form-64516494e54adad5ac574ba4-content-inner img').removeAttr('aria-hidden');
$('.omnisend-form-64516494e54adad5ac574ba4-content-inner img.omnisend-form-64516494e54adad5ac574ba4-background-image').attr('alt','a woman wearing ettika jewelry and watering can on the flowers');
  }
}); 

$(document).ready(function() {
    $('.banner.banner--content-align-center.banner--content-align-mobile-center.banner--medium.banner--stacked.banner--mobile-bottom .banner__content.banner__content--middle-center.page-width .banner__buttons a').attr('aria-label', 'shop now our best seller collection');
    $("footer.footer .footer-block.grid__item .rte a").attr("aria-label","Learn More About us");
    $('.link--text.list-menu__item.list-menu__item--link[href="https://ettika.myreturnscenter.com/"]').attr('aria-label', 'Returns, You will be leave ettika.com and redirect to ettika.returnscenter.com');
    $('.link.link--text.list-menu__item.list-menu__item--link[href="https://www.shareasale.com/shareasale.cfm?merchantID=91592"]').attr("aria-label","Affiliate Program, You wll be leave ettika.com and redirect to shareasale.com");
    $(".rte.umr h5").attr("aria-level","3");
    $(".elm.text-edit.gf-elm-left.gf-elm-center-md.gf-elm-center-sm.gf-elm-center-xs.gf_gs-text-paragraph-1.gf-elm-center-lg.con-h1").addClass("btm-text");
    $(".elm.text-edit.gf-elm-left.gf-elm-center-md.gf-elm-center-sm.gf-elm-center-xs.gf_gs-text-paragraph-1.gf-elm-center-lg.con-h1.btm-text br").remove();
    $('.elm.text-edit.gf-elm-left.gf-elm-center-md.gf-elm-center-sm.gf-elm-center-xs.gf_gs-text-paragraph-1.gf-elm-center-lg.con-h1.btm-text p font').contents().filter(function(){
      return this.nodeType == 3 && $.trim(this.nodeValue).length;
  }).wrap('<p class="new" />');
  $(".elm.text-edit.gf-elm-center.gf-elm-center-md.gf-elm-center-sm.gf-elm-center-xs.gf-elm-center-lg.h-level-1 h2").attr("aria-level","1");
  $('.button.button--secondary[href="/collections/back-necklaces"]').attr("aria-label","Shop now,new: back necklace");
  });
class A {
    constructor(o) {
        (this.element = o), (this.timezone = o.dataset.timezone || "UTC");
        const c = o.dataset.endTime;
        (this.endTime = this.parseTimezoneDate(c, this.timezone)),
            (this.daysElement = o.querySelector(".days")),
            (this.hoursElement = o.querySelector(".hours")),
            (this.minutesElement = o.querySelector(".minutes")),
            (this.secondsElement = o.querySelector(".seconds")),
            (this.updateTimer = this.updateTimer.bind(this)),
            this.start();
    }
    parseTimezoneDate(o, c) {
        const l = new Intl.DateTimeFormat("en-US", { timeZone: c, year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "numeric", second: "numeric", hour12: !1 });
        try {
            const r = new Date(o),
                s = l.formatToParts(r),
                e = {};
            return (
                s.forEach((t) => {
                    t.type !== "literal" && (e[t.type] = parseInt(t.value));
                }),
                new Date(Date.UTC(e.year, e.month - 1, e.day, e.hour, e.minute, e.second))
            );
        } catch (r) {
            return console.error("Error parsing date:", r), new Date(o);
        }
    }
getCurrentTimezoneTime() {
    const formatter = new Intl.DateTimeFormat("en-US", { 
        timeZone: this.timezone, 
        year: "numeric", 
        month: "numeric", 
        day: "numeric", 
        hour: "numeric", 
        minute: "numeric", 
        second: "numeric", 
        hour12: false 
    });

    // Get formatted parts (year, month, day, etc.)
    const formattedParts = formatter.formatToParts(new Date());
    const dateParts = {};
    
    formattedParts.forEach(part => {
        if (part.type !== "literal") {
            dateParts[part.type] = parseInt(part.value, 10);
        }
    });

    // Create a UTC date based on the extracted parts
    const currentTime = new Date(Date.UTC(
        dateParts.year, dateParts.month - 1, dateParts.day, 
        dateParts.hour, dateParts.minute, dateParts.second
    ));    
    return currentTime;
}
    start() {
        this.updateTimer(), (this.interval = setInterval(this.updateTimer, 1e3));
    }
    updateTimer() {
    const o = this.getCurrentTimezoneTime().getTime(),
        c = this.endTime - o;

    if (c <= 0) {
        this.element.classList.add("hide-this-countdown");
        clearInterval(this.interval);
        return;
    }

    const totalHours = Math.floor(c / (1e3 * 60 * 60)), 
        r = Math.floor((c % (1e3 * 60 * 60)) / (1e3 * 60)),
        s = Math.floor((c % (1e3 * 60)) / 1e3); 

    this.hoursElement.textContent = totalHours.toString().padStart(2, "0");
    this.minutesElement.textContent = r.toString().padStart(2, "0");
    this.secondsElement.textContent = s.toString().padStart(2, "0");
}

}
document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".countdown-timer").forEach((i) => {
        new A(i);
    });
});